import React, { useState, useEffect } from 'react';
import { fetchSliders,fetchCategory,fetchLetestDesign,fetchShopByType,
  fetchTraditionalJwalelryAndAllProduct,fetchAllProduct,fetchProductByReels } from "../api/apiService";
  import { BASE_URL } from '../constants';
import HomeSlider from "./HomeSlider";
import OfferNow from "./OfferNow";
import NewArrivalProduct from "./NewArrivalProduct"
import { Navigation, Autoplay } from "swiper/modules";
import WeekOffer from './WeekOffer';
import NewProduct from './NewProduct';
import BestMatchingSale from './BestMatchingSale';
import TrendingProduct from './TrendingProduct';
import Blogs from './blogs/Blogs'
import Brand from './Brand';
import Usp from './Usp';
import JewelleryCategories from './JewelleryCategories';
import SlideShowBanner1st from './SlideShowBanner1st';
import OccasionSection from './OccasionSection';
import TraditionalJewel from './TraditionalJewel';
import ShopbyReels from './ShopbyReels';
import ShopByBudget from './ShopByBudget';
import ShopConfidence from './ShopConfidence ';


const MainContent = () => {

 const [products, setProducts] = useState([]);
 const [loading, setLoading] = useState(true);
 const [sliders, setSliders] = useState([]);
 const [category, setCategory] = useState([]);
 const [newArrivalProduct, setNewArrival] = useState([]);
 const [shopbytype, setShopbyType] = useState([]);
 const [traditionalJwalelryAllproduct,setTraditionalJwalelryAllProduct]=useState([]);
 const [all_product,setAllProduct]=useState([]);
 const [allReelsProduct,setAllReelsProduct]=useState([]);
 const [combined, setCombined] = useState([]);

  useEffect(() => {
   
    // 🔹 Fetch sliders
    const loadSliders = async () => {
      try {
          // home slider data with function
        const slider_res = await fetchSliders();
        setSliders(slider_res?.data?.sliders || []);
        // category data with function
        const category_result = await fetchCategory();
        setCategory(category_result?.data?.categories || []);

        // Fetch Letest Design data with function
        const newArrivalProduct_result = await fetchLetestDesign();
        setNewArrival(newArrivalProduct_result?.data?.products || []);

        //FetchShopByType
         const shopbytype_result = await fetchShopByType();
        setShopbyType(shopbytype_result?.data?.shopbytype || []);
        // fetchTraditionalJwalelry
           const TraditionalJwalelry_result = await fetchTraditionalJwalelryAndAllProduct();
           setTraditionalJwalelryAllProduct(TraditionalJwalelry_result?.data || []);// fetchTraditionalJwalelry
           // fetchallproduct //
           const all_product_result = await fetchAllProduct();
           setAllProduct(all_product_result?.data?.all_product || []);
           
           const all_reels_product_result = await fetchProductByReels();
           setAllReelsProduct(all_reels_product_result?.data?.all_product_reels || []);



      } catch (err) {
        console.error("API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadSliders();
  }, []);


// console.log(traditionalJwalelryAllproduct,'combined');
   return (
    <>

      
      <HomeSlider sliders={sliders} />
      {/* <Usp/> */}
      <JewelleryCategories category={category}/>
      {/* <OfferNow/> */}
      <NewArrivalProduct newproduct={newArrivalProduct}/>
      <SlideShowBanner1st/>
      <ShopbyReels allReelsProduct ={allReelsProduct}/>
      <OccasionSection shopbytype ={shopbytype}/>
      
      <TraditionalJewel traditionalJwalelryAllproduct={traditionalJwalelryAllproduct}/>
      {/* <WeekOffer/> */}
      {/* <ShopByBudget/> */}
      {/* <NewProduct products={products} /> */}
      {/* <BestMatchingSale products={products} /> */}
      {/* <TrendingProduct products={products} /> */}
      <Blogs/>
      <ShopConfidence/>
      {/* <Brand/> */}
    </>
   )
};

export default MainContent;
